export default __webpack_public_path__ + "static/media/meslay9.58490c9f.jpg";